import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import Modal from "../../../components/modal";
import api from "../../../services/api";

export default ({ project }) => {
  const [filters, setFilters] = useState({ status: "open" });
  const [data, setData] = useState([]);
  const [selectedNeed, setSelectedNeed] = useState(null);

  useEffect(() => {
    fetchData();
  }, [filters]);

  const fetchData = async () => {
    try {
      const query = { status: filters.status, project_id: project._id };
      const { ok, data } = await api.post("/need/search", query);
      console.log(data);
      if (!ok) throw new Error("Error while fetching needs");
      setData(data);
    } catch (error) {
      console.error(error);
      toast.error("Error while fetching needs");
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-row justify-between gap-4 mb-4">
        <div className="flex gap-4">
          <button
            className={`px-4 py-2 rounded ${filters.status === "open" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
            onClick={() => setFilters({ ...filters, status: "open" })}>
            Open
          </button>
          <button
            className={`px-4 py-2 rounded ${filters.status === "close" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
            onClick={() => setFilters({ ...filters, status: "close" })}>
            Closed
          </button>
        </div>
        <Create
          onCreated={async (data) => {
            await fetchData();
            setSelectedNeed(data);
          }}
          project={project}
        />
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {data.map((e, i) => (
            <Card key={i} need={e} onClick={() => setSelectedNeed(e)} />
          ))}
        </div>
      </div>
      <EditModal
        need={selectedNeed}
        isOpen={!!selectedNeed}
        onClose={() => {
          setSelectedNeed(null);
          fetchData();
        }}
      />
    </div>
  );
};

const Card = ({ need, onClick }) => {
  return (
    <div className="flex flex-col no-underline hover:no-underline bg-white rounded-md shadow-md hover:shadow-lg overflow-hidden h-full cursor-pointer" onClick={onClick}>
      <div className="flex flex-col flex-1 group p-4">
        <div className="text-xl font-bold text-dull-black group-hover:underline">{need.name}</div>
        <div className="text-sm text-light-grey mt-2">
          {need.description?.substring(0, 90)}
          {need.description?.length > 100 ? "..." : ""}
        </div>
        <div className="flex-1" />
        <div className="mt-4 text-sm text-gray-500">Created {new Date(need.created_at).toLocaleDateString()}</div>
        <div className="flex items-center gap-3 mb-3">
          {need.user_avatar && <img src={need.user_avatar} alt={need.user_name} className="w-8 h-8 rounded-full" />}
          <div className="text-sm text-gray-600">{need.user_name}</div>
        </div>
      </div>
    </div>
  );
};
const EditModal = ({ isOpen, onClose, need }) => {
  const [values, setValues] = useState({});

  useEffect(() => {
    if (!need) return;
    setValues({
      name: need.name || "",
      description: need.description || "",
      status: need.status || "open",
    });
  }, [need]);

  const handleSubmit = async () => {
    try {
      const res = await api.put(`/need/${need._id}`, values);
      if (!res.ok) throw res;
      toast.success("Need updated!");
      onClose();
    } catch (e) {
      console.log(e);
      toast.error("Error updating need");
    }
  };
  return (
    <Modal isOpen={isOpen} className="max-w-3xl w-full p-6" onClose={onClose}>
      <div className="p-8 h-full">
        <div className="space-y-4">
          <div>
            <div className="text-sm font-medium mb-2">Name</div>
            <input className="projectsInput block w-full" value={values.name} onChange={(e) => setValues({ ...values, name: e.target.value })} />
          </div>
          <div>
            <div className="text-sm font-medium mb-2">Description</div>
            <textarea
              className=" block w-full"
              rows={4}
              value={values.description}
              onChange={(e) => setValues({ ...values, description: e.target.value })}
              style={{ whiteSpace: "pre-wrap" }}
            />
          </div>
          <div>
            <div className="text-sm font-medium mb-2">Status</div>
            <select className="block w-full" value={values.status} onChange={(e) => setValues({ ...values, status: e.target.value })}>
              <option value="open">Open</option>
              <option value="close">Closed</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button className="btn blue-btn w-32" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
};

const Create = ({ onCreated, project }) => {
  const [values, setValues] = useState({ name: "", description: "" });
  const [open, setOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      values.project_id = project._id;
      values.project_name = project.name;
      const res = await api.post("/need", values);
      if (!res.ok) throw res;
      toast.success("Need created!");
      setOpen(false);
      onCreated(res.data);
    } catch (e) {
      console.log(e);
      toast.error("Error creating need");
    }
  };

  return (
    <>
      <button className="btn blue-btn rounded-full shadow-lg" onClick={() => setOpen(true)}>
        Create new need
      </button>
      <Modal isOpen={open} className="max-w-3xl w-full p-6" onClose={() => setOpen(false)}>
        <div className="p-8">
          <h2 className="text-2xl font-semibold mb-4">Create need</h2>
          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <div className="text-sm font-medium mb-2">Name</div>
                <input className="projectsInput block w-full" name="name" value={values.name} onChange={(e) => setValues({ ...values, name: e.target.value })} required />
              </div>
            </div>
            <div className="flex justify-end mt-6">
              <button type="submit" className="btn blue-btn w-32">
                Create
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};
